import { render, staticRenderFns } from "./SelectCategory.vue?vue&type=template&id=12a00071&scoped=true"
import script from "./SelectCategory.vue?vue&type=script&lang=js"
export * from "./SelectCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a00071",
  null
  
)

export default component.exports